var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48551 0H30.5145C35.7534 0 40 4.24665 40 9.4855V30.5145C40 35.7534 35.7534 40 30.5145 40H9.48551C4.24666 40 0 35.7534 0 30.5145V9.4855C0 4.24665 4.24666 0 9.48551 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9125 1.08105H9.07471C4.65643 1.08105 1.07471 4.66277 1.07471 9.08105V30.9189C1.07471 35.3372 4.65642 38.9189 9.0747 38.9189H30.9125C35.3308 38.9189 38.9125 35.3372 38.9125 30.9189V9.08105C38.9125 4.66278 35.3308 1.08105 30.9125 1.08105Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.066 28.6291L21.9663 18.3147L21.1637 17.1482L16.085 9.76996L15.664 9.15851H9.42358L10.9456 11.3703L17.6983 21.1817L18.501 22.347L23.9266 30.2302L24.3476 30.8411H30.5882L29.066 28.6291ZM25.0892 29.4291L19.4524 21.2393L18.6497 20.0735L12.1089 10.5701H14.9225L20.2122 18.2557L21.0149 19.4215L27.903 29.4291H25.0892Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6498 20.0739L19.4524 21.2397L18.5008 22.3472L11.1996 30.8412H9.39917L17.6982 21.1819L18.6498 20.0739Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8368 9.15851L21.9664 18.3147L21.0148 19.4215L20.2122 18.2557L21.1638 17.1482L26.495 10.9429L28.0363 9.15851H29.8368Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.122f30bb729772f50bd0c2131fc00e85.svg";
export { ForwardRef as ReactComponent };